import { cloneDeep } from 'lodash';
import { calculate } from '@moleculeone/draw';
import type { Mol } from '@moleculeone/types';

import { SVGMol } from '../components/visualization/Compound/SVGMol';

export type SeedId = string | number;

export function applyMapping(mol: Mol, mapping: number[]) {
  const atomKeys = Object.keys(mol.atoms);

  if (atomKeys.length !== mapping.length) {
    return mol;
  }

  const molCopy = cloneDeep(mol);

  atomKeys.forEach(key => {
    const idx = Number(mol.atoms[key].idx);
    molCopy.atoms[key].classNum = mapping[idx];
  });

  return molCopy;
}

export function getDrawingRandomSeed(seedId: SeedId) {
  const seed = parseInt(SVGMol.randomSeeds[seedId], 10);

  return Number.isFinite(seed) ? seed : 0;
}

export function incrementDrawingRandomSeed(seedId: SeedId) {
  const seed = parseInt(SVGMol.randomSeeds[seedId], 10);
  const nextSeed = Number.isFinite(seed) ? seed + 1 : 1;

  SVGMol.randomSeeds[seedId] = String(nextSeed);

  return nextSeed;
}

export function calculateSeededPositions({
  mol,
  seedId,
  incrementSeed = false,
}: {
  mol: Mol;
  seedId: SeedId;
  incrementSeed?: boolean;
}) {
  let randomSeed;

  if (!incrementSeed) {
    randomSeed = getDrawingRandomSeed(seedId);
  } else {
    randomSeed = incrementDrawingRandomSeed(seedId);
  }

  return calculate(mol, {
    randomSeed,
  });
}
